module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-instagram-4.82241a65.jpg";